import { useState } from 'react'

const WA_NUMBER = '971503768662'
const WA_MESSAGE = encodeURIComponent(
  "Hi! With reference to your Website I\u2019m interested to know more about Victory Homes\u2019 properties & services. Could someone contact me please?"
)
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`

function WhatsAppFloat() {
  const [hovered, setHovered] = useState(false)

  return (
    <>
      <style>{`
        @keyframes wa-pulse {
          0%   { box-shadow: 0 0 0 0 rgba(197, 160, 89, 0.65); }
          70%  { box-shadow: 0 0 0 16px rgba(197, 160, 89, 0); }
          100% { box-shadow: 0 0 0 0 rgba(197, 160, 89, 0); }
        }
        @keyframes wa-spin-in {
          from { transform: rotate(-20deg) scale(0.85); opacity: 0; }
          to   { transform: rotate(0deg) scale(1); opacity: 1; }
        }
        .wa-float-btn {
          animation: wa-pulse 2.6s ease-out infinite;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
                      box-shadow 0.3s ease,
                      background 0.3s ease;
        }
        .wa-float-btn:hover {
          animation: none;
          transform: scale(1.18) rotate(8deg) !important;
          box-shadow: 0 8px 32px rgba(197, 160, 89, 0.55);
        }
        .wa-float-btn:active {
          transform: scale(1.05) rotate(4deg) !important;
        }
        .wa-tooltip {
          position: fixed;
          bottom: 94px;
          right: 24px;
          z-index: 9998;
          background: linear-gradient(135deg, #002E53 0%, #001a33 100%);
          color: #fff;
          font-family: 'Poppins', sans-serif;
          font-size: 13px;
          font-weight: 500;
          padding: 10px 16px;
          border-radius: 10px;
          white-space: nowrap;
          pointer-events: none;
          border: 1px solid rgba(197, 160, 89, 0.35);
          letter-spacing: 0.2px;
        }
        /* Arrow pointing down */
        .wa-tooltip::after {
          content: '';
          position: absolute;
          bottom: -7px;
          right: 22px;
          width: 13px;
          height: 13px;
          background: #002E53;
          transform: rotate(45deg);
          border-right: 1px solid rgba(197, 160, 89, 0.35);
          border-bottom: 1px solid rgba(197, 160, 89, 0.35);
        }
        .wa-tooltip-visible {
          animation: wa-spin-in 0.28s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
        .wa-icon-svg {
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        .wa-float-btn:hover .wa-icon-svg {
          transform: scale(1.15);
        }
      `}</style>

      {/* Tooltip — only mounts when hovered so animation replays each time */}
      {hovered && (
        <div className="wa-tooltip wa-tooltip-visible">
          💬 Chat with us on WhatsApp
        </div>
      )}

      {/* Main button */}
      <a
        href={WA_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="wa-float-btn"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          zIndex: 9999,
          width: '58px',
          height: '58px',
          borderRadius: '50%',
          background: hovered
            ? 'linear-gradient(135deg, #d4af6a 0%, #C5A059 100%)'
            : 'linear-gradient(135deg, #C5A059 0%, #a08440 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          cursor: 'pointer',
        }}
      >
        <svg
          className="wa-icon-svg"
          viewBox="0 0 32 32"
          width="32" height="32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 2C8.268 2 2 8.268 2 16c0 2.522.666 4.888 1.832 6.932L2 30l7.304-1.812A13.928 13.928 0 0016 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.6a11.54 11.54 0 01-5.864-1.6l-.42-.252-4.34 1.076 1.1-4.22-.276-.436A11.552 11.552 0 014.4 16C4.4 9.592 9.592 4.4 16 4.4c6.408 0 11.6 5.192 11.6 11.6 0 6.408-5.192 11.6-11.6 11.6z"
            fill="white"
          />
          <path
            d="M22.004 18.8c-.332-.168-1.964-.972-2.268-1.08-.304-.112-.524-.168-.744.168-.22.336-.856 1.08-1.048 1.304-.196.22-.388.248-.72.08-.332-.168-1.4-.516-2.664-1.644-.984-.876-1.648-1.96-1.84-2.292-.196-.336-.02-.516.148-.684.152-.152.336-.392.504-.588.168-.196.224-.336.336-.56.112-.22.056-.416-.028-.588-.084-.168-.744-1.792-1.02-2.456-.268-.644-.54-.556-.744-.556-.196 0-.416-.028-.636-.028-.22 0-.58.084-.884.416-.304.332-1.16 1.136-1.16 2.764 0 1.632 1.188 3.208 1.356 3.428.168.224 2.34 3.572 5.668 5.008.792.34 1.408.544 1.892.696.792.252 1.516.216 2.084.132.636-.096 1.96-.8 2.236-1.576.276-.776.276-1.44.196-1.576-.084-.14-.304-.224-.636-.392z"
            fill="white"
          />
        </svg>
      </a>
    </>
  )
}

export default WhatsAppFloat
